module.exports = __webpack_public_path__ + "img/hilight-1.37370aa0.png";